import React, {useState, useEffect} from 'react';
import { Link } from 'react-router';
import { formatDateMDYYYY } from '../../../utility/utils/dateUtil';
import Globals, { Keywords } from '../../../utility/constants/appConstants';

import EasyPayLastpayment from './easyPayLastPayment';
import EasyPay from './easyPay';
import Onetime from './oneTime';
import PrePay from './prePay';
import Locked from './locked';

const ServiceAgreement = ({serviceAgreement, setAccountSummaryState, sqftMapModalRef, uri, setIsOverlayLoading, paymentsCss, invoiceStatuses}) => {
    
    const [premium, setPremium] = useState(false);
    const [badDebt, setBadDebt] = useState(false);
    const [inActive, setInActive] = useState(false);
    const [queryString, setQueryString] = useState(window.location.search != ""?window.location.search:"");
    const labels = Globals.acc;
    
    useEffect(() => {
        if (Keywords.premiumList.indexOf(serviceAgreement.svcLine) !== -1) {
            setPremium(true);
        }
       
        if (serviceAgreement.isBadSalesAgreement !== 'N' && invoiceAmountDue(serviceAgreement) > 0 && serviceAgreement.inactiveReason !== 'SSP' && serviceAgreement.inactiveReason !== 'NRN') {
            setBadDebt(true);
        }
        if (serviceAgreement.inactiveStatus === 'INA' && serviceAgreement.inactiveReason === 'SSP'){
            setInActive(true);
        }
    }, []);

    const invoiceAmountDue = (item) => {
        if(item && item.Invoices.length > 0){
            let invoiceOpen = item.Invoices.filter((x) => x.invoiceOpen === "Y");
            
            var totalInvoiceBalance = 0.00
            for(var i = 0; i < invoiceOpen.length; i++) { 
                totalInvoiceBalance += invoiceOpen[i].invoiceBalance;
            }
            return totalInvoiceBalance.toFixed(2);
        }
        return 0;
    }

    const { lstSvc, viewSvcDetails, inActiveBlock, inActiveBlockContact } = labels;
    let rightarea;
    if (badDebt === false && inActive === false) {
      
        const setServiceNames = JSON.parse(localStorage.getItem('loyaltyServiceNames'));
        let activeServiceNames = setServiceNames && setServiceNames.length > 0 ? setServiceNames : [];
        let sample = {
            name : serviceAgreement.svcLineDesc,
            salesAgreement : serviceAgreement.salesAgrNum
        }
        
        activeServiceNames = [...new Set([...activeServiceNames, sample])];
        localStorage.setItem('loyaltyServiceNames', JSON.stringify(activeServiceNames));
    }

    /* invoice status */
    let invoices = serviceAgreement.Invoices.length > 0 ? serviceAgreement.Invoices : [];
    
    const isProcessing = invoices.length > 0 && invoiceStatuses ? invoices.some(invoice => invoiceStatuses.processing.includes(invoice.invoiceNum)) : false;
    const isFailed = invoices.length > 0 && invoiceStatuses ? invoices.some(invoice => invoiceStatuses.failed.includes(invoice.invoiceNum)) : false;
    const isNotFound = invoices.length > 0 && invoiceStatuses ? invoices.some(invoice => invoiceStatuses.not_found.includes(invoice.invoiceNum)) : false;
    const isOnQueue = invoices.length > 0 && invoiceStatuses ? invoices.some(invoice => invoiceStatuses.onqueue.includes(invoice.invoiceNum)) : false;
    const isPending = invoices.length > 0 && invoiceStatuses ? invoices.some(invoice => invoiceStatuses.pending.includes(invoice.invoiceNum)) : false;
    const isSuccess = invoices.length > 0 && invoiceStatuses ? invoices.some(invoice => invoiceStatuses.success.includes(invoice.invoiceNum)) : false;
    const isActionEnabled = !(isProcessing || isOnQueue || isPending || isSuccess);
    
    if (badDebt === false) {
      let type = serviceAgreement.ServiceAgreementType;
      let arBalance = serviceAgreement.arBalance;
      switch (true) {
        
        case type === Keywords.prePay:
          rightarea = <PrePay isActionEnabled={isActionEnabled} labels={labels} prepayDspSvcCntFlag={serviceAgreement.prepayDspSvcCntFlag} prepayDspSvcCnt={serviceAgreement.prepayDspSvcCnt}  arBalance={serviceAgreement.arBalance} paymentsCss={paymentsCss} />;
        break;
        
        case (type === Keywords.easyPay && arBalance <= 0):
          rightarea = <EasyPayLastpayment isActionEnabled={isActionEnabled} serviceAgreement={serviceAgreement} labels={labels} paymentsCss={paymentsCss} />;
        break;
        
        case type === Keywords.easyPay:
          rightarea = <EasyPay isActionEnabled={isActionEnabled} arBalance={serviceAgreement.arBalance} labels={labels} paymentsCss={paymentsCss} />;
        break;
        
        case type === Keywords.oneTime:
          rightarea = <Onetime isActionEnabled={isActionEnabled} arBalance={serviceAgreement.arBalance} labels={labels} paymentsCss={paymentsCss} />;
        break;
        
        default: rightarea=null;
        break;
      }
    }

    return (
      <div className='row'>
        <div className='col-12'>
          {badDebt ?
            <Locked isActionEnabled={isActionEnabled} serviceAgreement={serviceAgreement} labels={labels} invoiceAmountDue={invoiceAmountDue(serviceAgreement)} paymentsCss={paymentsCss} /> :
            <div className={`row ${paymentsCss["mb-16"]} ${paymentsCss["tru-mma-main-content-box"]}`}>
              <div
                className={`col-12 col-md-5 col-lg-6 ${paymentsCss["gfw-3"]} ${paymentsCss["p-30"]} text-center ${paymentsCss["text-md-left"]} ${paymentsCss["tru-mma-main-content"]}`}>
                <div className={`${paymentsCss["mb-10"]}`}>
                  <span className={`d-block ${paymentsCss["gfs-24"]} ${paymentsCss["gfs-lg-30"]} glh-1 mb-10`}>
                    {serviceAgreement.svcLineDesc}
                  </span>
                  <span className={`${paymentsCss["gfs-lg-20"]} ${paymentsCss["mb-5"]} ${paymentsCss["text-gray-dark"]} d-block`}>
                    {`${serviceAgreement.LatestServiceDate ? lstSvc + ' ' + formatDateMDYYYY(serviceAgreement.woMostRecentComplDate) : ' '}`}
                  </span>
                  {serviceAgreement.inactiveStatus === 'ACT' && <Link to={`/my-account/my-services/${queryString}`}
                    className={`${paymentsCss["gfs-lg-20"]} ${paymentsCss["tru-mma-main-link"]}`}>{viewSvcDetails}</Link>}
                </div>
                {inActive && <>
                  <br />
                  <div className='row'>
                    <div className='col-2'>
                      <img src='/images/myAccount/Icons/exclamation-circle-solid.svg' width='40' height='40' />
                    </div>
                    <div className='col-9'>
                      <span className={`${paymentsCss["gfs-14"]} ${paymentsCss["gfw-4"]}`}>
                        {inActiveBlock}
                        <span className={`${paymentsCss["js-phoneno"]}`}>{inActiveBlockContact}</span>
                      </span>
                    </div>
                  </div>
                  </>}
              </div>
              <div className={`align-items-center col-12 col-md-3 col-lg-3 d-flex flex-column ${paymentsCss["gfs-10"]} justify-content-center ${paymentsCss["tru-mma-main-content"]}`}></div>
              {rightarea}
            </div>}
        </div>
      </div>
    );
}

export default ServiceAgreement;